const knownFolders = [
  'school_content', 'student_images', 'staff_images', 'student_documents',
  'admit_card', 'print_headers', 'print_content', 'homework', 'chat', 'exam_descriptive'
];

export function getTenantSlug(): string {
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return '_default';
  }
  // Match server's tenant.middleware.ts: tenantSlug = hostname.split('.')[0]
  // For sirmvedu.com → 'sirmvedu'
  // For demo.prabhaktech.com → 'demo'
  const parts = host.split('.');
  return parts[0] || '_default';
}

export function normalizeUploadUrl(value: string | null | undefined, defaultModulePath: string, fallback = ''): string {
  if (!value) return fallback;

  // Check if it's a default/fallback asset.
  const isDefaultAsset = /default_|no_image/i.test(value);

  const slug = getTenantSlug();
  let clean = value.startsWith('/') ? value : `/${value}`;

  // Ensure it starts with /uploads/
  if (!clean.startsWith('/uploads/')) {
    if (!value.includes('/') && !value.includes('\\')) {
      clean = `/uploads/${defaultModulePath}/${value}`;
    } else {
      clean = `/uploads/${value.replace(/^\/+/, '')}`;
    }
  }

  if (isDefaultAsset) {
    // For default/fallback assets, strip any tenant slug.
    if (slug) {
      const prefix = `/uploads/${slug}/`;
      if (clean.startsWith(prefix)) {
        clean = `/uploads/${clean.substring(prefix.length)}`;
      }
    }
    const parts = clean.split('/');
    if (parts.length > 3 && !knownFolders.includes(parts[2])) {
      parts.splice(2, 1);
      clean = parts.join('/');
    }
  } else if (slug) {
    // For custom assets, prepend tenant slug if not already present.
    const tenantPrefix = `/uploads/${slug}/`;
    if (!clean.startsWith(tenantPrefix)) {
      clean = `/uploads/${slug}/${clean.substring(9)}`;
    }
  }

  return clean;
}

/**
 * Resolve a student image path for display.
 */
export function studentImgUrl(img: string | null | undefined, fallback = ''): string {
  if (!img) {
    if (fallback) return normalizeUploadUrl(fallback, 'student_images');
    return '';
  }
  return normalizeUploadUrl(img, 'student_images');
}

/**
 * Resolve a staff image path for display.
 */
export function staffImgUrl(img: string | null | undefined, fallback = ''): string {
  if (!img) {
    if (fallback) return normalizeUploadUrl(fallback, 'staff_images');
    return '';
  }
  return normalizeUploadUrl(img, 'staff_images');
}

/**
 * Generic upload path resolver.
 */
export function uploadUrl(value: string | null | undefined, modulePath: string, fallback = ''): string {
  return normalizeUploadUrl(value, modulePath, fallback);
}

